import { Injectable, computed, signal } from '@angular/core';

/**
 * App-wide blocking loader with reference counting.
 * `show()` returns a disposer; call it once to hide.
 */
@Injectable({ providedIn: 'root' })
export class GlobalLoaderService {
  private readonly activeCount = signal(0);

  readonly visible = computed(() => this.activeCount() > 0);

  show(): () => void {
    this.activeCount.update((n) => n + 1);
    let closed = false;
    return () => {
      if (closed) return;
      closed = true;
      this.activeCount.update((n) => (n > 0 ? n - 1 : 0));
    };
  }
}
